import { WINDOW_IVA_NAMESPACE, ERROR_STORAGE_NAME } from '../constants';
export const storeMessage = (msg) => {
    if (!window[WINDOW_IVA_NAMESPACE]) {
        window[WINDOW_IVA_NAMESPACE] = { [ERROR_STORAGE_NAME]: new Set() };
    }
    if (!window[WINDOW_IVA_NAMESPACE][ERROR_STORAGE_NAME]) {
        window[WINDOW_IVA_NAMESPACE][ERROR_STORAGE_NAME] = new Set();
    }
    window[WINDOW_IVA_NAMESPACE][ERROR_STORAGE_NAME].add(msg);
};
export const hasMessage = (msg) => {
    if (!window[WINDOW_IVA_NAMESPACE] ||
        !window[WINDOW_IVA_NAMESPACE][ERROR_STORAGE_NAME]) {
        return false;
    }
    return window[WINDOW_IVA_NAMESPACE][ERROR_STORAGE_NAME].has(msg);
};
